/* Single-open accordion for the iGrid FAQ.
 *
 * The markup ships expanded, so with JavaScript off every answer is still on
 * the page and still matches the FAQPage schema below it. Collapsing happens
 * here, on load, which is also why the trigger's aria-expanded starts at true
 * in the template rather than false.
 */

(() => {
  const setOpen = (item, open) => {
    item.trigger.setAttribute('aria-expanded', String(open));
    item.panel.hidden = !open;
  };

  const init = (scope) => {
    (scope || document).querySelectorAll('[data-igrid-faq-accordion]').forEach((list) => {
      if (list.dataset.igridFaqReady) return;
      list.dataset.igridFaqReady = 'true';

      const items = Array.from(list.querySelectorAll('[data-igrid-faq-item]'))
        .map((root) => ({
          trigger: root.querySelector('[data-igrid-faq-trigger]'),
          panel: root.querySelector('[data-igrid-faq-panel]'),
        }))
        .filter((item) => item.trigger && item.panel);

      items.forEach((item) => setOpen(item, false));

      items.forEach((item) => {
        item.trigger.addEventListener('click', () => {
          const opening = item.trigger.getAttribute('aria-expanded') !== 'true';
          items.forEach((other) => setOpen(other, false));
          if (opening) setOpen(item, true);
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
